var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { InlineTextCell } from '@features/Attachments/components/InlineTextCell';
import { useAttachmentFieldCommit } from '../hooks/useAttachmentFieldCommit';
/**
 * Technician and Certification # share one component because they differ only in which key they
 * PATCH — the contentEditable commit/revert behaviour lives once in the shared `InlineTextCell`.
 *
 * Technician is deliberately a free-text input and NOT a dropdown: the original brief asked for a
 * technician picker, the requester then withdrew it to keep parity with the legacy screen, so no
 * `technician_id` FK exists (plan Decision 2). Do not "improve" this into a select.
 */
export function AttachmentTextFieldCell({ item, inspectionId, field, placeholder }) {
    var _a;
    const { commit } = useAttachmentFieldCommit(inspectionId, item.id);
    const handleCommit = (nextValue) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const payload = { [field]: nextValue };
        const result = yield commit(payload);
        if (!result.success)
            return { success: false, error: result.error };
        return { success: true, value: (_a = result.row[field]) !== null && _a !== void 0 ? _a : '' };
    });
    return React.createElement(InlineTextCell, { value: (_a = item[field]) !== null && _a !== void 0 ? _a : '', commit: handleCommit, placeholder: placeholder });
}
